import {
  Box,
  Table,
  Thead,
  Tbody,
  Td,
  Th,
  Tr,
  Heading,
} from "@vygruppen/spor-react"
import { ActiveTrip } from "src/types/DeveloperTypes"
import { TripIdLink } from "src/components/links/TripIdLink"
import { useActiveTrips } from "src/api/dashboard"
import { withErrorBoundry } from "src/api/withErrorBoundry"
import { TaxiAdminCard } from "src/components/layout/TaxiAdminCard"
import React from "react"

function OngoingTrips() {
  const activeTrips = useActiveTrips()

  return (
    <TaxiAdminCard>
      <Heading as="h1">
        {activeTrips?.ongoingTrips.length} pågående tur(er)
      </Heading>
      {activeTrips && (
        <Box flex="1" textAlign="left" mt="6">
          <OngoingTripsTable trips={activeTrips.ongoingTrips} />
        </Box>
      )}
    </TaxiAdminCard>
  )
}

type ActiveTripTableProps = {
  trips: ActiveTrip[]
}

function OngoingTripsTable(props: ActiveTripTableProps) {
  return (
    <Table size="sm" variant="simple">
      <Thead>
        <Tr>
          <Th>Ønsket avreise</Th>
          <Th>TripId</Th>
          <Th>Selskap</Th>
          <Th>Status</Th>
          <Th>Teknologileverandør</Th>
        </Tr>
      </Thead>
      <Tbody>
        {props.trips.map((item) => (
          <Tr key={item.tripId}>
            <Td>{item.requestedPickUpTime}</Td>
            <Td>
              <TripIdLink tripId={item.tripId} />
            </Td>
            <Td>{item.companyName}</Td>
            <Td>{item.status}</Td>
            <Td>{item.technologyProvider}</Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  )
}

export default withErrorBoundry(OngoingTrips)
